import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=0bccc97a&scoped=true&"
import script from "./Assignment.vue?vue&type=script&lang=js&"
export * from "./Assignment.vue?vue&type=script&lang=js&"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=0bccc97a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccc97a",
  null
  
)

export default component.exports